// extracted by mini-css-extract-plugin
module.exports = {"content":"Layout_content__GvZDz","desktop":"Layout_desktop__iDD1_","phone":"Layout_phone__csb4h"};